import { transformSDKBytesToRESTBytes } from '@wix/sdk-runtime/transformations/bytes';
import { transformRESTBytesToSDKBytes } from '@wix/sdk-runtime/transformations/bytes';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { resolveUrl } from '@wix/metro-runtime';
function resolveWixIdentityOauth2V1Oauth2NgUrl(opts) {
    const domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/oauth2',
                destPath: '/v1/oauth',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/oauth2',
                destPath: '/v1/oauth',
            },
        ],
        'users._base_domain_': [
            {
                srcPath: '/v1/oauth/device/verify',
                destPath: '/v1/oauth/device/verify',
            },
            {
                srcPath: '/v1/oauth/manage/user-code',
                destPath: '/v1/oauth/manage/user-code',
            },
        ],
        _: [
            {
                srcPath: '/_api/oauth2',
                destPath: '/v1/oauth',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings }));
}
/**
 * Creates an access token.
 *
 *
 * The endpoint accepts raw HTTP requests. You must pass the request's body
 * parameters formatted as bytes in the raw HTTP request's `body` field,
 * following this template:
 * `{"grantType": "client_credentials", "client_id": "<APP_ID>", "client_secret": "<APP_SECRET_KEY>", "instance_id": "<INSTANCE_ID>"}`.
 *
 * When the call succeeds, Wix returns `{"statusCode": 200}` and the created access
 * token in the `body` field of the raw HTTP response.
 *
 * In case the call fails, Wix returns the relevant `4XX` error code in the raw
 * HTTP response's `statusCode` field and details
 * about the error in `body`. Error details follow the
 * [conventions of the Internet Engineering Task Force (IETF)](https://datatracker.ietf.org/doc/html/rfc6749#appendix-A.7).
 */
export function token(payload) {
    function __token({ host }) {
        const serializedData = transformPaths(payload, [
            { transformFn: transformSDKBytesToRESTBytes, paths: [{ path: 'body' }] },
        ]);
        const metadata = {
            entityFqdn: 'wix.identity.oauth.v1.refresh_token',
            method: 'POST',
            methodFqn: 'wix.identity.oauth2.v1.Oauth2Ng.Token',
            url: resolveWixIdentityOauth2V1Oauth2NgUrl({
                protoPath: '/v1/oauth/token',
                data: serializedData,
                host,
            }),
            data: serializedData,
            transformResponse: (payload) => transformPaths(payload, [
                {
                    transformFn: transformRESTBytesToSDKBytes,
                    paths: [{ path: 'body' }],
                },
            ]),
        };
        return metadata;
    }
    return __token;
}
//# sourceMappingURL=identity-oauth-v1-refresh-token-oauth.http.js.map